import React from "react";
import ToolMenuIconButton from "../../../../common/ToolMenuIconButton";
import { RiLineChartLine } from "react-icons/ri";

export interface IProps {
  /**
   * ボタンがクリックされた場合に呼び出されます
   */
  onClick?: () => void;
}

class ChartsButton extends React.Component<IProps> {
  render(): JSX.Element {
    return (
      <ToolMenuIconButton
        icon={<RiLineChartLine />}
        tooltip="Charts"
        onClick={this.props.onClick}
      />
    );
  }
}

/**
 * チャート一覧ボタン
 */
export default ChartsButton;
